<div class="aem-Grid aem-Grid--12 aem-Grid--default--12">
    <div class="responsivegrid aem-GridColumn aem-GridColumn--default--12">
        <div *ngIf="!userInfo" class="loading-spinner">
            <div alt="Loading..." class="large progress">
                <div class="prog1">
                    <div class="prog2"></div>
                </div>
            </div>
        </div>
        <div *ngIf="userInfo" class="aem-Grid aem-Grid--12 aem-Grid--default--12">
            <div class="subscription-registration aem-GridColumn aem-GridColumn--default--12 subscription-registration-wrapper">
                <app-subscribe-freshpass 
                    *ngIf="userInfo" 
                    [userInfo]="userInfo"
                    [selectPlanStepRedirect]="selectPlanStepRedirect">
                </app-subscribe-freshpass>
            </div>
            <div *ngIf="showFreshpassTilesComponent"
                 [innerHTML]="freshpassTilesComponent | safeHtml"
                 class="experiencefragment aem-GridColumn aem-GridColumn--default--12">
            </div>
            <div *ngIf="showPartnersComponent"
              class="container p0 clear-fix mb56">
                <app-partnerscarousel
                  [carouselData]="partnersData"
                  [configObj]="configObj" [userInfo]="userInfo">
                </app-partnerscarousel>
            </div>
            <div *ngIf="showFreshpassBelowTilesComponent"
                 [innerHTML]="freshpassBelowTilesComponent | safeHtml"
                 class="experiencefragment aem-GridColumn aem-GridColumn--default--12">
            </div>
            <div class="experiencefragment aem-GridColumn aem-GridColumn--default--12">
                <div class="column-control aem-GridColumn aem-GridColumn--default--12">
                    <div class="column-control-wrapper ">
                        <div class="row col-md-auto">
                            <div class="container-fluid">
                                <div class="row abs-no-gutters">

                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" id="slim-padding">
                                        <div class="experiencefragment section">
                                            <div *ngIf="showFrequentlyAskedQuestion"
                                                 [innerHTML]="frequentlyAskedQuestion | safeHtml"></div>
                                        </div>
                                        <div class="experiencefragment section">
                                            <div *ngIf="showTermsContent" [innerHTML]="termsContent | safeHtml"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

